<section id="main-section" class="pd-t40 pd-b40 pd-l40 pd-r40 pd-sm-20 lightgrey-bg">
    <div class="smallContainer mg-auto">
        <app-report-list [program]="programData"></app-report-list>
        
    </div>
</section>